module.exports = __webpack_public_path__ + "media/icons/document-search-41e1736c.png";